import React, { useEffect } from 'react';

interface PreferenceCenterLinkProps {
  className?: string;
  text?: string;
  onClick?: () => void;
}

const PreferenceCenterLink: React.FC<PreferenceCenterLinkProps> = ({
  className = '',
  text = 'Consent Preferences',
  onClick,
}) => {
  useEffect(() => {
    window.Termly?.initialize?.();
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.Termly?.initialize?.();
    onClick?.();
  };

  return (
    <a
      href="#cookie-preferences"
      className={`termly-display-preferences ${className}`}
      aria-label="Open consent preferences"
      onClick={handleClick}
    >
      {text}
    </a>
  );
};

PreferenceCenterLink.displayName = 'PreferenceCenterLink';

export default PreferenceCenterLink;
